import { clsx } from 'clsx'

import type { Image } from '~publish/legacy/composer/composer/entities/factories'

import { getOrientation, ImageOrientation } from '../../../Common/utils'

import styles from './ImagePreview.module.css'

export const ImagePreview = ({
  image,
}: {
  image?: Image | null
}): React.JSX.Element => {
  const height = image?.height
  const width = image?.width
  const orientation = getOrientation({ height, width })

  return (
    <div
      data-testid="preview-image"
      className={clsx(
        styles.imageWrapper,
        orientation === ImageOrientation.Landscape && styles.landscape,
      )}
    >
      <img
        className={clsx(
          styles.image,
          orientation === ImageOrientation.Portrait && styles.portrait,
        )}
        src={image?.url}
        alt="Google Business post preview"
      />
    </div>
  )
}
